"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var FormHelperText_1 = tslib_1.__importDefault(require("@material-ui/core/FormHelperText"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Error = function (_a) {
    var isVisible = _a.isVisible, children = _a.children, rest = tslib_1.__rest(_a, ["isVisible", "children"]);
    if (!children) {
        return null;
    }
    return (react_1.default.createElement(StyledFormHelperText, tslib_1.__assign({}, rest, { error: isVisible, classes: { error: 'error' } }), children));
};
exports.Error.displayName = 'FOS_Error';
var StyledFormHelperText = styled_components_1.default(FormHelperText_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    color: ", ";\n    height: 1.5rem;\n    font-size: 1.2rem;\n    font-family: ", ";\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.25;\n    letter-spacing: normal;\n    position: absolute;\n    top: 100%;\n    margin-top: 0.4rem;\n\n    && .error {\n      color: ", ";\n    }\n  }\n"], ["\n  && {\n    color: ", ";\n    height: 1.5rem;\n    font-size: 1.2rem;\n    font-family: ", ";\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.25;\n    letter-spacing: normal;\n    position: absolute;\n    top: 100%;\n    margin-top: 0.4rem;\n\n    && .error {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.red[500];
});
var templateObject_1;
